import FAQSection from "../components/FAQSection";
import SellerSearchBar from "../components/UserDashboardComponents/SellerSearchBar";
import UserStatsSec from "../components/UserDashboardComponents/UserStatsSec";

const Dashboard = () => {
  return (
    <div className="p-4">
      <SellerSearchBar defaultFetch={false} />
      <UserStatsSec />
      <FAQSection />
    </div>
  );
};

export default Dashboard;
